// Entry point for the build script in your package.json
import '@hotwired/turbo-rails'
import './controllers'
import 'trix'
import '@rails/actiontext'
import './trix_editor'
import 'chartkick'
import Chart from 'chart.js/auto'
import 'chartjs-adapter-date-fns'
import ahoy from 'ahoy.js'

window.Chart = Chart
window.ahoy = ahoy

window.addEventListener('turbo:load', (event) => {
  console.log('turbo:load')
  // A/B test layout, stamped once per page on the category page wrapper
  // (outside all fragment caches); undefined elsewhere, so JSON.stringify
  // drops the key from event properties on non-category pages.
  const layoutElement = document.querySelector('[data-layout]')
  const pageLayout = layoutElement?.dataset.layout
  // ?layout=a|b previews are admins checking a variant, not visitors: the
  // server records no Category Page View for them, so record no entry events either.
  // navigator.webdriver: automated browsers (Puppeteer, Playwright, Selenium),
  // even with a spoofed user agent — keeps them out of billed clicks/video views.
  const trackEvents = !layoutElement?.dataset.layoutPreview && !navigator.webdriver
  const track = (name, properties) => {
    if (trackEvents) ahoy.track(name, properties)
  }
  const trackClick = (name, properties) => track(name, { ...properties, layout: pageLayout })
  ;[...document.querySelectorAll('.entry-event')].forEach(function (item) {
    item.addEventListener('click', function (e) {
      trackClick('Entry Click', {
        entry_id: parseInt(e.target.dataset['entryId']),
        category_id: parseInt(e.target.dataset['categoryId']),
      })
    })
  })
  ;[...document.querySelectorAll('.inbound-link')].forEach(function (item) {
    item.addEventListener('click', function (e) {
      console.log('inbound-link')
      trackClick('Inbound Link Click', {
        entry_id: parseInt(e.target.dataset['entryId']),
        category_id: parseInt(e.target.dataset['categoryId']),
      })
    })
  })
  ;[...document.querySelectorAll('.outbound-link')].forEach(function (item) {
    item.addEventListener('click', function (e) {
      console.log('outbound-link')
      trackClick('Outbound Link Click', {
        entry_id: parseInt(e.target.dataset['entryId']),
        category_id: parseInt(e.target.dataset['categoryId']),
      })
    })
  })
  ;[...document.querySelectorAll('.entry-video')].forEach(function (item) {
    let playTime = 0
    let startTime
    // data-autoplayed is stamped by the category-videos controller (autoplay
    // categories only); muted is the state when the event fires.
    const playbackFlags = () => ({
      autoplay: item.dataset['autoplayed'] === 'true',
      muted: item.muted,
    })

    item.addEventListener('play', function (e) {
      startTime = new Date().getTime()
      //console.log("Play event:", {
      //  entryId: e.target.dataset["entryId"],
      //  startTime,
      //});
      track('Video Play', {
        entry_id: parseInt(e.target.dataset['entryId']),
        ...playbackFlags(),
      })
    })

    item.addEventListener('timeupdate', function (e) {
      if (!item.paused && !item.ended && startTime) {
        const currentTime = new Date().getTime()
        playTime += currentTime - startTime
        startTime = currentTime
        //console.log("Timeupdate event:", { playTime, currentTime });
      }
    })

    const handlePauseOrEnd = function (e) {
      if (startTime) {
        const currentTime = new Date().getTime()
        playTime += currentTime - startTime
        startTime = null
        //console.log("Pause or End event:", { playTime, currentTime });
      }
      if (playTime > 0) {
        track('Video Pause or End', {
          entry_id: parseInt(e.target.dataset['entryId']),
          play_time: playTime / 1000, // convert to seconds
          ...playbackFlags(),
        })
      }
      playTime = 0
    }

    item.addEventListener('pause', handlePauseOrEnd)
    item.addEventListener('ended', handlePauseOrEnd)
  })
  ;[...document.querySelectorAll('.cta-event')].forEach(function (item) {
    item.addEventListener('click', function (e) {
      ahoy.track('Cta Click', { cta_id: parseInt(e.target.dataset['ctaId']) })
    })
  })
  ;[...document.querySelectorAll('.badge-event')].forEach(function (item) {
    item.addEventListener('click', function (e) {
      ahoy.track('Badge Click', {
        venue_id: parseInt(e.target.dataset['venueId']),
      })
    })
  })
  ;[...document.querySelectorAll('.search-event')].forEach(function (item) {
    item.addEventListener('click', function (e) {
      ahoy.track('Search Click')
    })
  })
  ;[...document.querySelectorAll('.show-more-entries')].forEach(
    function (item) {
      item.addEventListener('click', function (e) {
        const dataElement = e.currentTarget || e.target

        trackClick('Show More Entries Click', {
          category_id: parseInt(dataElement.dataset['categoryId']),
        })
      })
    }
  )
})
